import styled from "@emotion/styled";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

export const ZeroPaddingAccordion = styled(Accordion)`
  margin: 0;
  padding: 0;
  background-color: transparent;
  &.Mui-root {
    padding: 0;
    margin: 0;
    min-height: 0;
    min-height: 40px;
  }
  &.Mui-expanded {
    padding: 0;
    margin: 0;
    min-height: 0;
    min-height: 40px;
    background-color: transparent;
  }
`;

export const ZeroPaddingAccordionDetails = styled(AccordionDetails)`
  margin: 0;
  padding: 0.25rem 0 0.5rem;
`;

export const ZeroPaddingAccordionSummary = styled(AccordionSummary)`
  margin: 0 !important;
  min-height: 2rem !important;
  padding: 0 !important;
  justify-content: flex-start !important;

  .MuiAccordionSummary-content {
    flex: 0 0 auto;
    width: auto;
    padding: 0;
    margin: 0 !important;
    min-height: 2rem;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .MuiAccordionSummary-expandIconWrapper {
    margin-left: 0.25rem;
    color: ${(p) => p.theme.text.colors.brand};
  }
`;
